var map = {
	"./applications": 191,
	"./applications.js": 191,
	"./dist": 192,
	"./dist.js": 192,
	"./dropbox": 193,
	"./dropbox.js": 193,
	"./google-drive": 194,
	"./google-drive.js": 194,
	"./onedrive": 196,
	"./onedrive.js": 196,
	"./osjs": 182,
	"./osjs.js": 182,
	"./web": 197,
	"./web.js": 197,
	"./webdav": 198,
	"./webdav.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 490;


//////////////////
// WEBPACK FOOTER
// ./javascript/vfs/transports ^\.\/.*$
// module id = 490
// module chunks = 0